import { login, logout } from "@/api/login";
import { getUserInfo } from "@/api/home";

const user = {
  state: {
    token: "",
    userInfo: ""
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo;
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo)
          .then((response) => {
            if (response.status !== 200) {
              reject(response);
              return false;
            }
            localStorage.setItem("token", response.data.token);
            commit("SET_TOKEN", response.data.token);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 获取用户信息
    GetUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getUserInfo()
          .then((response) => {
            commit("SET_USER_INFO", response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 退出登录
    Logout({ commit }) {
      return new Promise((resolve, reject) => {
        logout()
          .then((response) => {
            commit("SET_TOKEN", "");
            commit("SET_USER_INFO", "");
            localStorage.setItem("token", "");
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  }
};

export default user;
